"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCianAnalyticsObjectPage = getCianAnalyticsObjectPage;
function getCianAnalyticsObjectPage() {
  return window?.CianAnalytics?.service.config.page || {};
}